import React from 'react';
import './Rules.css';

const Rules = () => {
  return (
    <div className="rules-page">
      <div className="rules-hero">
        <div className="hero-content">
          <h1 className="hero-title">League Constitution</h1>
          <p className="hero-subtitle">The official rules and regulations of The Golden Goose Fantasy Football League</p>
        </div>
      </div>
      
      <div className="rules-container">
        <div className="rules-content">
          <section id="article1" className="rule-section">
            <div className="section-header">
              <div className="section-number">01</div>
              <h2 className="section-title">League Entry and Prize Payout Structure</h2>
            </div>
            <div className="section-content">
              <p className="section-intro">Welcome to The Golden Goose redraft league. Hopefully everyone will enjoy themselves, stop being sensitive, don't leave the chat and some will win some cash.</p>
              
              <div className="subsection">
                <h3 className="subsection-title">Entry Fee, Prizes and Punishments</h3>
                <div className="prize-grid">
                  <div className="prize-item prize-first">
                    <div className="prize-rank">1st Place</div>
                    <div className="prize-amount">$1,400.00</div>
                  </div>
                  <div className="prize-item prize-second">
                    <div className="prize-rank">2nd Place</div>
                    <div className="prize-amount">$600.00</div>
                  </div>
                  <div className="prize-item prize-third">
                    <div className="prize-rank">3rd Place</div>
                    <div className="prize-amount">$200.00</div>
                  </div>
                  <div className="prize-item prize-bonus">
                    <div className="prize-rank">Most Points</div>
                    <div className="prize-amount">$200.00</div>
                  </div>
                </div>
                
                <div className="special-prizes">
                  <div className="special-prize">
                    <span className="prize-icon">🏆</span>
                    <span>Best Team Drafted (voted by league on draft day) - Surprise Gift</span>
                  </div>
                  <div className="special-prize">
                    <span className="prize-icon">🎭</span>
                    <span>Worst Team Drafted (voted by league on draft day) - Surprise Gift</span>
                  </div>
                  <div className="special-prize">
                    <span className="prize-icon">🧦</span>
                    <span>Fist Kicker - Socks</span>
                  </div>
                </div>
                
                <div className="important-note">
                  <div className="note-header">⚠️ Important Rule</div>
                  <p>The team manager that finishes in last place after the <strong>regular season</strong> will wear a dress during next year's draft party for the first 3 rounds or pay a fine of $150 which will be divided between team managers not including the team manager that is paying the fine. If this rule is not adhered to by the team manager, the team manager will be removed from the league.</p>
                </div>
              </div>
            </div>
          </section>

          <section id="article2" className="rule-section">
            <div className="section-header">
              <div className="section-number">02</div>
              <h2 className="section-title">Roster and Lineups</h2>
            </div>
            <div className="section-content">
              <div className="roster-grid">
                <div className="roster-section">
                  <h3 className="subsection-title">Starters</h3>
                  <div className="position-list">
                    <div className="position-item">QB</div>
                    <div className="position-item">RB</div>
                    <div className="position-item">RB</div>
                    <div className="position-item">WR</div>
                    <div className="position-item">WR</div>
                    <div className="position-item">WR</div>
                    <div className="position-item">TE</div>
                    <div className="position-item">FLEX (RB, WR, TE)</div>
                    <div className="position-item">DEF</div>
                    <div className="position-item">K</div>
                  </div>
                </div>
                
                <div className="roster-section">
                  <h3 className="subsection-title">Bench</h3>
                  <div className="bench-info">
                    <div className="bench-item">
                      <span className="bench-count">7</span>
                      <span className="bench-label">Bench Spots</span>
                    </div>
                    <div className="bench-item">
                      <span className="bench-count">1</span>
                      <span className="bench-label">IR Spot</span>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="ir-rules">
                <h3 className="subsection-title">IR Spot Rules</h3>
                <p>There is one IR spot per team. There are no Covid IR spots this season. The IR spot is only for players who have the following designations (IR, IR-R, PUP-R, NFI, NFI-R). Players with OUT and SUSP are not eligible. After a player is activated from such designation, you are to remove the player from IR within 24 hours. You will be notified by the commissioner that the player has come off IR. If not done after the 24 hours, the player will be removed from the team and placed on the free agents list.</p>
              </div>
            </div>
          </section>

          <section id="article3" className="rule-section">
            <div className="section-header">
              <div className="section-number">03</div>
              <h2 className="section-title">General Rules and Chat Rules</h2>
            </div>
            <div className="section-content">
              <div className="rules-list">
                <div className="rule-item">
                  <span className="rule-icon">🚫</span>
                  <span>If owner abandons team during the season said team owner will be removed from the league for following season</span>
                </div>
                <div className="rule-item">
                  <span className="rule-icon">⚖️</span>
                  <span>Commissioner will be responsible to ensure the most competitive line up is set for each week by making sure the highest projection players are in the starting line up. If such team happens to win the championship then the 2nd place team will be the champion</span>
                </div>
                <div className="rule-item">
                  <span className="rule-icon">🔒</span>
                  <span>If a team is not in the playoffs, the team may not drop or pick up players after regular season</span>
                </div>
                <div className="rule-item">
                  <span className="rule-icon">🏆</span>
                  <span>All ties in playoffs will be decided by most points in regular season</span>
                </div>
                <div className="rule-item">
                  <span className="rule-icon">📊</span>
                  <span>If same number of points, then go to head to head record</span>
                </div>
                <div className="rule-item">
                  <span className="rule-icon">🪙</span>
                  <span>If have same head to head record will be decided by coin flip</span>
                </div>
              </div>
              
              <div className="chat-rules">
                <h3 className="subsection-title">Chat Rules</h3>
                <div className="rules-list">
                  <div className="rule-item">
                    <span className="rule-icon">💬</span>
                    <span>All team owners must participate within the league and its group chat</span>
                  </div>
                  <div className="rule-item">
                    <span className="rule-icon">🤝</span>
                    <span>Includes responding to trade offer with as simple as a decline</span>
                  </div>
                  <div className="rule-item">
                    <span className="rule-icon">🗳️</span>
                    <span>If accused by member of league to be non-participant will be put to remaining 11 owners on league vote whether you remain for following season or not</span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section id="article4" className="rule-section">
            <div className="section-header">
              <div className="section-number">04</div>
              <h2 className="section-title">Standings</h2>
            </div>
            <div className="section-content">
              <p>Your standings are based on your head-to-head record. If there is a tie the tie breaker will be based on points scored. Our season goes from weeks 1 through 14. After week 14 the season is over. The bottom 6 teams are locked into their standings. The top 6 standings will be determined via playoffs.</p>
            </div>
          </section>

          <section id="article5" className="rule-section">
            <div className="section-header">
              <div className="section-number">05</div>
              <h2 className="section-title">Playoffs</h2>
            </div>
            <div className="section-content">
              <div className="playoff-structure">
                <div className="playoff-info">
                  <h3 className="subsection-title">Playoff Structure</h3>
                  <ul className="playoff-list">
                    <li>Top teams 1-6 based off record</li>
                    <li>Teams in 1st and 2nd place get a bye week on week 15</li>
                    <li>Team in 3rd place will play team in 6th place</li>
                    <li>Team in 4th place will play team in 5th place</li>
                    <li>If teams have the same record, see article III subsection c, d and e</li>
                  </ul>
                </div>
                
                <div className="playoff-details">
                  <p>Playoffs will be reseeded after week 15. The 1 seed will play the lowest seeded team from week 15. The 2 seed will play the higher seed from week 15. The quarterfinals will determine the standings for 5th and 6th place. The teams that finished 7th through 12th during the regular season (week 1 through week 14) will finish the season in those respective positions. The semifinal and final will determine the top 4 standings. The winners of the semifinals will play for 1st and 2nd. The losers will play for 3rd place. The loser of the 3rd place match up will finish in 4th place. Only teams in the playoffs will have access to the waiver wire FAAB.</p>
                </div>
              </div>
            </div>
          </section>

          <section id="article6" className="rule-section">
            <div className="section-header">
              <div className="section-number">06</div>
              <h2 className="section-title">Waiver Wire (FAAB)</h2>
            </div>
            <div className="section-content">
              <div className="faab-info">
                <div className="faab-budget">
                  <div className="budget-amount">$100</div>
                  <div className="budget-label">Season Budget</div>
                </div>
                <p>The waiver wire will now be done through FAAB every Tuesday and processed early Wednesday morning. Each owner will have a $100 budget to spend on waiver picks through the season. If you are eliminated during playoffs and not competing for 1st, 2nd or 3rd. You will no longer be allowed to access waivers. FAAB stands for Free Agent Auction Budget. It is a waiver system that gives every manager an equal opportunity at picking up free agents off waivers. FAAB uses a blind bidding system where each manager submits a bid for a player in the form of a dollar amount. Managers organize those bids based on preference. Then, the system awards the free agents to the highest bidders.</p>
                
                <div className="important-note">
                  <div className="note-header">⚠️ Important</div>
                  <p>Once a player has started his game, you are not allowed to drop that player until following weeks waivers.</p>
                </div>
              </div>
            </div>
          </section>

          <section id="article7" className="rule-section">
            <div className="section-header">
              <div className="section-number">07</div>
              <h2 className="section-title">Scoring and Settings</h2>
            </div>
            <div className="section-content">
              <p>See Yahoo League Settings. Scoring and Settings</p>
            </div>
          </section>

          <section id="article8" className="rule-section">
            <div className="section-header">
              <div className="section-number">08</div>
              <h2 className="section-title">Contacting League Officers</h2>
            </div>
            <div className="section-content">
              <p>Your league officers are available if you have any questions or are in need of assistance. If your question pertains to a feature provided by our fantasy football hosting provider Yahoo, please utilize their support resources before contacting a league officer. For league-specific issues, please contact the main league commissioner first or the co-commissioner second if the main commissioner is not available. If you cannot contact the main commissioner or co-commissioner, and your issue is time-sensitive (for instance, if you are requesting a roster modification because you don't have access to the Internet), please use the WhatsApp chat to make your request. In this way, we can verify the time of your request and make your roster change retroactively if necessary.</p>
              
              <div className="commissioner-info">
                <h3 className="subsection-title">Main League Commissioner</h3>
                <div className="contact-card">
                  <div className="contact-name">Chris Mez</div>
                  <div className="contact-phone">(407) 780-0840</div>
                </div>
              </div>
            </div>
          </section>

          <section id="article9" className="rule-section">
            <div className="section-header">
              <div className="section-number">09</div>
              <h2 className="section-title">Creating New League Rules</h2>
            </div>
            <div className="section-content">
              <p>When a league dispute arises which has not been addressed in the league constitution, a discussion will ensue on possible resolutions to the dispute. Based on these discussions, the Commissioner will create an online poll so that owners can vote on an appropriate course of action. The league will follow the course of action based on a plurality of league votes. Also, we will create a new rule in the league constitution based on the result of the league poll so that similar disputes will be resolved in the same manner.</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Rules;
